<template>
  <v-sheet :color="incolor" class="main">
    <ul>
      <li v-for="i,index in items" :key="index">
        <span class="hex">
          <span v-if="i['id'] == 'blank'"></span>
          <span
            v-else
            @mouseover="cube_click(i['id'])"
            :class="{center:index == 5}"
            class="hexIn text-caption text-truncate">
            {{i[$store.state.lang+'_name']}}
          </span>
        </span>
      </li>
    </ul>
  </v-sheet>
</template>
<script>
export default{
  name:'cube',
  methods:{
    cube_click(v){
      this.$emit('cube_hover',v);
    },
  },
  props:{
    items:{
      type:Array,
    },
    incolor:{
      type:String,
    },
  },
}
</script>
<style scoped>
.main{
}
ul{
  margin-top:5px;
  margin-left:-85px;
  list-style: none;
  width: 520px;
  height:300px;
}
li{
  float: left;
  margin: 0 5px;
  height: 96px;
}
.hex {
  overflow: hidden;
  display: block;
  width: 100px;
  height: 116px;
  transform: rotate(-60deg) skewY(30deg);
}
.hexIn {
  background: #5C6BC0;
  color:#fff;
  display: block;
  width: 100px;
  height: 116px;
  line-height: 116px;
  text-align: center;
  transform: skewY(-30deg) rotate(60deg);
}
.hexIn:hover{
  background:#F57F17;
}
li:nth-child(7n + 5) {
  margin-left: 60px;
}
.center{
  background:grey;
}
</style>
